// Optiene el carrito
async function getCart() {
  const response = await fetch('/cart.js');
  const cart = await response.json();
  return cart;
}
// Guarda una copia del carrito y de las cantidades de los productos en localStorage
async function saveCart() {
  const cart = await getCart();
  // Guarda una copia del carrito en localStorage
  localStorage.setItem('cartItems', JSON.stringify(cart.items.reverse())); // Guardamos los productos en orden inverso para que se añadan en el mismo orden
  // Guarda las cantidades de los productos en localStorage
  let cartQuantities = {};
  for (let item of cart.items) {
    // las punteras y empeines (order 2 y 3), cuya cantidad sea 1 no contabilizan en el total de productos
    let noContabilizable = (item.properties.Order == 2 || item.properties.Order == 3) && item.quantity == 1;
    if (cartQuantities[item.variant_id]) {
      if (!noContabilizable) {
        cartQuantities[item.variant_id] += item.quantity;
      }
    } else {
      if (noContabilizable) {
        cartQuantities[item.variant_id] = 0;
      } else {
        cartQuantities[item.variant_id] = item.quantity;
      }
    }
  }
  localStorage.setItem('cartItemsQuantities', JSON.stringify(cartQuantities)); // Guardamos las variantes con sus cantidades
}
//Obtiene el carrito de localStorage
function getCartFromLocalStorage() {
  // Recupera el carrito de localStorage
  const cart = JSON.parse(localStorage.getItem('cartItems'));
  // Convierte la cadena de vuelta en un objeto
  return cart;
}
//Obtiene las cantidades de los productos en el carrito de localStorage
function getCartQuantitiesFromLocalStorage() {
  // Recupera el carrito de localStorage
  const cartQuantities = JSON.parse(localStorage.getItem('cartItemsQuantities'));
  // Convierte la cadena de vuelta en un objeto
  return cartQuantities;
}
//Obtiene las cantidades del inventario de los productos en el carrito de localStorage
function getCartInventoryCountFromLocalStorage() {
  // Recupera el carrito de localStorage
  const cartInventoryCount = JSON.parse(localStorage.getItem('cartItemsInventory'));
  // Convierte la cadena de vuelta en un objeto
  return cartInventoryCount;
}
//Comprueba si hay disponibilidad de suelas relacionadas
function checkAvailability(productHandle, quantity) {
  const cart = getCartFromLocalStorage();
  const cartQuantities = getCartQuantitiesFromLocalStorage();
  let available = true;
  for (let item of cart) {
    if (cartQuantities[item.variant_id] >= 2) {
      available = false;
    }
  }
  return available;
}

// Añadir productos complementarios al carrito
async function handleAddToCart(productHandle, variantId, quantity) {
  const variantMetafields = await getVariantMetafields(productHandle, variantId); // Función alojada en pwd-custom-api.js
  const cart = await getCart();
  let itemsToAdd = [];
  //Punteras: Comprueba si hay punteras relacionadas
  if (variantMetafields && variantMetafields.node && variantMetafields.node.related_variants_toes) {
    const fullToesId = variantMetafields.node.related_variants_toes.value;
    const idToesParts = fullToesId.split('/');
    const idToes = idToesParts[idToesParts.length - 1];
    if (idToes) {
      let isInCart = false;
      for (let item of cart.items) {
        if (item.variant_id == idToes && item.properties.Grupo == variantId) {
          isInCart = true;
        }
      }
      //Añadiendo punteras a la lista de productos
      // Se añade 1 como cantidad para que no se contabilice en el total de productos pero si se muestre en el carrito
      if (!isInCart) {
        itemsToAdd.push({
          id: idToes,
          quantity: 1,
          properties: {
            Grupo: variantId,
            Order: 3,
          },
        });
      }
    }
  }
  //Empeines: Comprueba si hay empeines relacionados
  if (variantMetafields && variantMetafields.node && variantMetafields.node.related_variants_instep) {
    const fullInstepsId = variantMetafields.node.related_variants_instep.value;
    const idInstepsParts = fullInstepsId.split('/');
    const idInsteps = idInstepsParts[idInstepsParts.length - 1];
    if (idInsteps) {
      let isInCart = false;
      for (let item of cart.items) {
        if (item.variant_id == idInsteps && item.properties.Grupo == variantId) {
          isInCart = true;
        }
      }
      //Añadiendo empeines a la lista de productos
      // Se añade 1 como cantidad para que no se contabilice en el total de productos pero si se muestre en el carrito
      if (!isInCart) {
        itemsToAdd.push({
          id: idInsteps,
          quantity: 1,
          properties: {
            Grupo: variantId,
            Order: 2,
          },
        });
      }
    }
  }
  //Suelas: Comprueba si hay suelas relacionadas
  if (variantMetafields && variantMetafields.node && variantMetafields.node.related_variants_soles) {
    const fullSolesId = variantMetafields.node.related_variants_soles.value;
    const idSolesParts = fullSolesId.split('/');
    const idSoles = idSolesParts[idSolesParts.length - 1];
    //Añadiendo suelas a la lista de productos a añadir al carrito
    // Se añade el doble de la cantidad del producto principal
    if (idSoles) {
      itemsToAdd.push({
        id: idSoles,
        quantity: quantity * 2,
        properties: {
          Grupo: variantId,
          Order: 1,
        },
      });
      //await addProductsToCart(itemsToAdd); // Función alojada en pwd-custom-api.js
    }
  }
  return itemsToAdd;
}

// Se ejecuta justo antes del checkout
async function executeBeforeCheckout() {
  //Guarda el carrito actual en localStorage
  await saveCart();
  //Elimina los productos del carrito que no se desean (empeines y punteras que tengan cantidad 1)
  const cart = await getCart();
  let updates = [];
  for (let item of cart.items) {
    if ((item.properties.Order == 2 || item.properties.Order == 3) && item.quantity == 1) {
      updates.push(0);
    } else {
      updates.push(item.quantity);
    }
  }
  await updateProductsToCart(updates); // Función alojada en pwd-custom-api.js
  // Redirige al usuario a la página de checkout
  window.location.href = '/checkout';
}

// Comprueba el carrito cada vez que se carga la página de carrito
async function checkCart(reloadPage) {
  //Comprobamos las lineas del carrito
  //const actualCart = document.querySelectorAll('[id*="CartItem-"]');
  const actualCart = await getCart();
  const actualDOMCart = document.querySelectorAll('[id*="CartItem-"]');
  let savedCart = [];
  let savedCartJSON = '';
  if (getCartFromLocalStorage() != null) {
    savedCart = getCartFromLocalStorage();
    savedCartJSON = JSON.stringify(savedCart);
  }
  console.log(saveCart);
  let savedCart_Modify = [...savedCart];
  //Comprobamos si las cantidade de complementos son correctas
  let servicios = [];
  savedCart.forEach((item) => {
    if (item.properties.Order == null) {
      servicios.push(item);
    }
  });
  savedCart_Modify.forEach((item) => {
    if (item.properties.Order == 1) {
      servicios.forEach((servicio) => {
        if (servicio.id == item.properties.Grupo) {
          item.quantity = servicio.quantity * 2;
        }
      });
    } else if (item.properties.Order == 2 || item.properties.Order == 3) {
      servicios.forEach((servicio) => {
        if (servicio.id == item.properties.Grupo) {
          if (item.quantity > servicio.quantity * 2) {
            item.quantity = servicio.quantity * 2;
          }
        }
      });
    }
  });
  const savedCar_ModificadotJSON = JSON.stringify(savedCart_Modify);
  const areDifferent =
    savedCartJSON !== savedCar_ModificadotJSON ||
    actualCart.items.length != savedCart.length ||
    actualDOMCart.length != savedCart.length;
  //Si las lineas de carrito no coinciden con las guardadas en localStorage
  //o las cantidades de los complementos no son correctas
  //y el carrito actual no está vacio
  //console.log(actualCart.items.length, actualDOMCart.length, savedCart.length, areDifferent);
  if (areDifferent && actualCart.items.length) {
    //Eliminamos el carrito actual
    await clearCart();
    //Añadimos los productos guardados en localStorage (punteras y empeines con cantidad 1 eliminados al ir al checkOut)
    await addProductsToCart(savedCart);
    // Guardamos el nuevo carrito en localStorage
    await saveCart();
    //Recargamos la página
    if (reloadPage) {
      location.reload(true);
    }
  }
}
